import { range } from "lodash";
import { getWidth } from "../common";

const columns = 15;
export default range(columns).map(current => {
  const field = `switch_tactile_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
